export default __webpack_public_path__ + "static/studyoffice-office4-799ced07789ef5431101a49483427b61.jpg";